import { Quantity } from './Quantity';

export type { TypeQuantityProps } from './types';
export default Quantity;
